import { createContext} from 'react';

export const NotificationAlertContext = createContext(null);